<template>
  <div class="summary-shop-tab">
    <div class="ivu-tabs-tab ivu-tabs-tab-active">
      {{ shopName }}
      <i-badge :count="badgeCount" />
    </div>
  </div>
</template>

<script>
import { Badge } from 'view-design'
export default {
  components: {
    'i-badge': Badge,
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    shopId() {
      return this.$store.getters['ConvertSummary/getShopId']
    },
    shopName() {
      return this.$store.getters['ConvertSummary/getShopName']
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    badgeCount() {
      return this.search.summary.length
    },
  },
  methods: {},
}
</script>

<style lang="scss">
.summary-shop-tab {
  .ivu-tabs-tab {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    cursor: pointer;
    text-decoration: none;
    position: relative;
    margin: 0;
    margin-right: 4px;
    height: 31px;
    padding: 5px 16px 4px;
    border: 1px solid #dcdee2;
    border-bottom: 0;
    border-radius: 4px 4px 0 0;
    transition: all 0.3s ease-in-out;
    background: #f8f8f9;
    font-size: 14px;
  }
  .ivu-tabs-tab-active {
    height: 32px;
    padding-bottom: 5px;
    background: #fff;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    border-color: #dcdee2;
    color: #2d8cf0;
  }
  .ivu-badge {
    position: absolute;
    top: -5px;
    right: -5px;
  }
}
</style>
